import React, { Component } from "react";
import { message, Popconfirm, Tooltip, Space, Tag } from "antd";
import { EditOutlined, StopOutlined, CheckCircleOutlined, PlusOutlined, DeleteOutlined, ApartmentOutlined, ArrowLeftOutlined, TagsOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, TableItem, ModalItem, Form, FormItem, InputItem, ErrorItem, MensajeError } from "../../../../Components/Items";
import EtapasProduccionCrud from "../EtapasOrdenProduccionPU/EtapasProduccionCrud";
import ModalMotivosFlujoPU from "../MotivosEtapasPU/ModalMotivosFlujoPU";

class FlujosProduccionPU extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    flujos: [],
    modalVisible: false,
    flujoEditandoId: null,
    guardando: false,
    flujoAbierto: null,
    flujoMotivos: null,
  };

  componentDidMount() {
    this.cargarFlujos();
  }

  cargarFlujos = () => {
    this.setState({ loading: true });
    axios
      .post("flujosProduccionPU/selectTodosFlujos", { empresaId: this.props.empresaId, valor: 3 }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ flujos: res.data.flujos || [] });
        } else {
          MensajeError({ message: "Error al cargar los flujos de producción" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  abrirModal = (flujo = null) => {
    this.setState({ modalVisible: true, flujoEditandoId: flujo?._id || null }, () => {
      this.formRef.current?.resetFields();
      if (flujo) this.formRef.current?.setFieldsValue({ nombre: flujo.nombre, descripcion: flujo.descripcion });
    });
  };

  cerrarModal = () => this.setState({ modalVisible: false, flujoEditandoId: null });

  onFinish = (values) => {
    const editando = !!this.state.flujoEditandoId;
    this.setState({ guardando: true });
    axios
      .post(
        editando ? "flujosProduccionPU/editarFlujo" : "flujosProduccionPU/agregarFlujo",
        { ...values, empresaId: this.props.empresaId, ...(editando ? { flujoId: this.state.flujoEditandoId } : {}) },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success(editando ? "Flujo actualizado correctamente" : "Flujo creado correctamente");
          this.cerrarModal();
          this.cargarFlujos();
        } else {
          MensajeError({ message: res.data.error || "Error al guardar el flujo" });
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  llamarAccion = (ruta, flujoId, textoExito) => {
    axios
      .post(`flujosProduccionPU/${ruta}`, { flujoId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success(textoExito);
        } else {
          MensajeError({ message: res.data.error || "No se pudo completar la acción" });
        }
        this.cargarFlujos();
      })
      .catch(() => MensajeError({ message: "Error al conectar con el servidor" }));
  };

  render() {
    if (this.state.flujoAbierto) {
      return (
        <>
          <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 12 }}>
            <ButtonItem icon={<ArrowLeftOutlined />} onClick={() => this.setState({ flujoAbierto: null }, this.cargarFlujos)}>
              Volver a flujos
            </ButtonItem>
            <strong style={{ fontSize: 16 }}>{this.state.flujoAbierto.nombre}</strong>
          </div>
          <EtapasProduccionCrud scope={{ flujoId: this.state.flujoAbierto._id }} />
        </>
      );
    }

    const columns = [
      { title: "Flujo", dataIndex: "nombre", key: "nombre", render: (nombre, record) => (record.esMaquila ? <>{nombre} <Tag color="purple">Sistema</Tag></> : nombre) },
      { title: "Descripción", dataIndex: "descripcion", key: "descripcion" },
      { title: "Etapas", dataIndex: "totalEtapas", key: "totalEtapas", align: "center" },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        align: "center",
        render: (estado) => (estado === 1 ? <Tag color="green">Activo</Tag> : <Tag color="red">Deshabilitado</Tag>),
      },
      {
        title: "Acción",
        key: "accion",
        align: "center",
        render: (_, record) => (
          <Space>
            <Tooltip title="Etapas y diagrama">
              <ButtonItem type="default" size="small" lila icon={<ApartmentOutlined />} onClick={() => this.setState({ flujoAbierto: record })} />
            </Tooltip>
            <Tooltip title="Motivos por etapa">
              <ButtonItem type="default" size="small" naranja icon={<TagsOutlined />} onClick={() => this.setState({ flujoMotivos: record })} />
            </Tooltip>
            {this.props.permisoEditar && !record.esMaquila && (
              <Tooltip title="Editar">
                <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.abrirModal(record)} />
              </Tooltip>
            )}
            {this.props.permisoDeshabilitar && !record.esMaquila &&
              (record.estado === 1 ? (
                <Popconfirm title="¿Deshabilitar este flujo?" onConfirm={() => this.llamarAccion("deshabilitarFlujo", record._id, "Flujo deshabilitado")}>
                  <Tooltip title="Deshabilitar">
                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
              ) : (
                <Popconfirm title="¿Habilitar este flujo?" onConfirm={() => this.llamarAccion("habilitarFlujo", record._id, "Flujo habilitado")}>
                  <Tooltip title="Habilitar">
                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              ))}
            {this.props.permisoEliminar && !record.esMaquila && (
              <Popconfirm
                title="¿Eliminar este flujo y sus etapas? Solo se puede si ninguna matriz ni orden lo usa."
                onConfirm={() => this.llamarAccion("eliminarFlujo", record._id, "Flujo eliminado")}
              >
                <Tooltip title="Eliminar">
                  <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} />
                </Tooltip>
              </Popconfirm>
            )}
          </Space>
        ),
      },
    ];

    return (
      <>
        <div style={{ marginBottom: 16, display: "flex", justifyContent: "flex-end" }}>
          {this.props.permisoAgregar && (
            <ButtonItem type="primary" olivo icon={<PlusOutlined />} onClick={() => this.abrirModal()}>
              Agregar flujo
            </ButtonItem>
          )}
        </div>
        <TableItem loading={this.state.loading} size="small" dataSource={this.state.flujos} columns={columns} rowKey="_id" />

        <ModalMotivosFlujoPU
          visible={!!this.state.flujoMotivos}
          flujo={this.state.flujoMotivos}
          puedeEditar={this.props.permisoEditar}
          onCerrar={() => this.setState({ flujoMotivos: null })}
        />

        <ModalItem
          title={this.state.flujoEditandoId ? "Editar flujo de producción" : "Agregar flujo de producción"}
          visible={this.state.modalVisible}
          spinning={this.state.guardando}
          onCancel={this.cerrarModal}
          width="40%"
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="ModalFlujoProduccionPU"
            layout
            bottom={
              <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Guardar
              </ButtonItem>
            }
            onFinish={this.onFinish}
            onFinishFailed={(e) => ErrorItem(e)}
          >
            <FormItem name="nombre" label="Nombre" required max={100} margin pattern>
              <InputItem placeholder="Nombre del flujo" />
            </FormItem>
            <FormItem name="descripcion" label="Descripción" margin>
              <InputItem placeholder="Descripción" />
            </FormItem>
          </Form>
        </ModalItem>
      </>
    );
  }
}

const tienePermiso = (state, id) => state.user.tipo === 0 || !!state.user.permisos.find((v) => v.permisoId.toString() === id)?.activado;

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoAgregar: tienePermiso(state, "6a9b3076e58adfd453df65c8"),
  permisoEditar: tienePermiso(state, "6a9b3083e58adfd453df65c9"),
  permisoDeshabilitar: tienePermiso(state, "6a9b3094e58adfd453df65cb"),
  permisoEliminar: tienePermiso(state, "6a9b30a4e58adfd453df65f1"),
});

export default connect(mapStateToProps)(FlujosProduccionPU);
